module.exports = __webpack_public_path__ + "static/time-a1747c64975789dd5db9b28a7fcd1d41.png";